    <div class="wrapper">
        <img src="./assets/icons/globe.svg" alt="globe">
        <h1>התקדמנו...</h1>
        <p>המערכת אינה נתמכת בדפדפן שלך עליך להיכנס למערכת באחד הדפדפנים הנתמכים:</p>
        <p>edge, chrome בגרסה 79 ומעלה או safari</p>
        <span>תודה!</span>
    </div>


    
    

